import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import SolutionsSection from "../components/SolutionsSection";
import ProductsSection from "../components/ProductsSection";
import WhyChooseUs from "../components/WhyChooseUs";
import PartnersSection from "../components/PartnersSection";
import CustomersSection from "../components/CustomersSection";
import ContactCTA from "../components/ContactCTA";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <SolutionsSection />
      <WhyChooseUs />
      <PartnersSection />
      <CustomersSection />
      <ContactCTA />
      <Footer />
    </>
  );
}
